import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';

import { CloseOutlined } from '@mui/icons-material';

import { EditAllergies } from '../';
import {
  dialogHeaderStyles,
  menuProps,
  textFieldSx
} from '../../../../../Common/components/Styles/InputStyles';

import {
  modalCloseIconSx,
  modalContentSx,
  modalHeaderSx,
  modalSx,
  modalTitleSx
} from './MHxSoapStyles';

const MHxEditModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="edit-allergies-title"
      slotProps={{
        paper: {
          sx: modalSx
        }
      }}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            Allergies: John Smith
          </Typography>
        </Box>

        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{ color: '#424242' }}>
          <CloseOutlined />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 0}}>
        <EditAllergies onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
};

MHxEditModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default MHxEditModal;
